import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { TableParamsProvider } from 'business/providers/table-params';
import { useFilterData } from 'technical/filter-data';
import { useMediaType } from 'technical/media/hooks';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';

import { RingComplianceFilters } from './components/filters';
import { RingComplianceHeader } from './components/ring-compliance-header';
import { RingComplianceSelectedCount } from './components/ring-compliance-selected-count';
import { RingComplianceTable } from './components/ring-compliance-table';
import { useRingComplianceReportFilterParams } from './hooks/use-filter-params';
import { MobileRingComplianceReportPage } from './mobile';
import { RingComplianceReportFiltersProvider } from './providers/filters';
import { RingComplianceReportFilterData } from './types';

export const ORDER_FIELD = 'ringNumber';
export const ORDER_TYPE = 'descend';

export function RingComplianceReportPage() {
  const { t } = useTranslation();

  useHead({
    title: t('user.menu.sections.qualityControl.ringComplianceReport.title'),
  });

  const { filterData, setFilterData } =
    useFilterData<RingComplianceReportFilterData>();

  const { isMobile } = useMediaType();

  const {
    initialFilters,
    initialCurrentPage,
    initialPageSize,
    initialSortField,
    initialSortOrder,
  } = useRingComplianceReportFilterParams();

  if (isMobile) {
    return <MobileRingComplianceReportPage />;
  }

  return (
    <TableParamsProvider
      defaultPageSize={initialPageSize}
      defaultCurrentPage={initialCurrentPage}
      defaultSortField={initialSortField}
      defaultSortOrder={initialSortOrder}
    >
      <RingComplianceReportFiltersProvider initialFilters={initialFilters}>
        <SingleCardPageWithFilterCardLayout
          title={t(
            'user.menu.sections.qualityControl.ringComplianceReport.title',
          )}
          header={<RingComplianceHeader />}
          filters={
            <CustomFilterCard
              footer={
                <SelectedItemsFooter>
                  <RingComplianceSelectedCount filterData={filterData} />
                </SelectedItemsFooter>
              }
            >
              <RingComplianceFilters />
            </CustomFilterCard>
          }
        >
          <RingComplianceTable setFilterData={setFilterData} />
        </SingleCardPageWithFilterCardLayout>
      </RingComplianceReportFiltersProvider>
    </TableParamsProvider>
  );
}
